import { useFieldArray, useFormContext } from "react-hook-form";
import React, { ChangeEvent } from "react";
import { Flex, Text } from "@mantine/core";
import Hint from "@/shared/ui/hint";
import { TBaseKeyword, TNewOrderForm } from "@/entities/new-order";
import { getDatesBetween } from "@/shared/helpers";
import { throwNewToastError } from "@/Utils/MainUtils";
import { Checkbox } from "@/shared/ui/checkbox";

type TRateAdditionProps = {
  countryIndex: number;
};

export const RateAddition = ({ countryIndex }: TRateAdditionProps) => {
  const { control, watch } = useFormContext<TNewOrderForm>();
  const { update } = useFieldArray({
    control: control,
    name: "countriesList",
  });

  const { dateStart, dateStop, countriesList } = watch();

  const country = countriesList[countryIndex];

  const handleChooseRateValue = (event: ChangeEvent<HTMLInputElement>) => {
    if (!dateStart || !dateStop) {
      throwNewToastError("Please select start and end date");
      return;
    }

    const dateArray = getDatesBetween(dateStart, dateStop);

    const newCountryRates: TBaseKeyword = JSON.parse(
      JSON.stringify(country.keywords),
    );

    if (event.target.checked) {
      dateArray.forEach((date) => {
        if (!newCountryRates[date]) {
          newCountryRates[date] = {};
        }
        newCountryRates[date][event.target.value] = 0;
      });
    } else {
      dateArray.forEach((date) => {
        if (newCountryRates[date]) {
          delete newCountryRates[date][event.target.value];
        }
      });
    }

    update(countryIndex, { geo: country.geo, keywords: newCountryRates });
  };

  const getSelectedRates = (curKey: string) => {
    if (
      dateStart &&
      country?.keywords &&
      typeof country.keywords === "object" &&
      country.keywords[dateStart] &&
      typeof country.keywords[dateStart] === "object"
    ) {
      return Object.keys(country.keywords[dateStart]).includes(curKey);
    }
    return false;
  };

  return (
    <Flex gap="lg">
      <Flex gap="md">
        <Flex gap={8} w={139} py="md" px={0} justify="flex-end">
          <Text>Rates</Text>
          <Hint popupText="Select a rating" />
        </Flex>
        <Flex align="center" gap="md">
          <Flex align="center" gap={12}>
            <Text>4-star</Text>
            <Checkbox
              id={`rate4star${countryIndex}`}
              name="rate"
              value="4 star rates"
              checked={getSelectedRates("4 star rates")}
              onChange={handleChooseRateValue}
            />
          </Flex>
          <Flex align="center" gap={12}>
            <Text>5-star</Text>
            <Checkbox
              id={`rate5star${countryIndex}`}
              name="rate"
              value="5 star rates"
              checked={getSelectedRates("5 star rates")}
              onChange={handleChooseRateValue}
            />
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
};
